<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
  >
    <template v-slot:activator="{ on, attrs }">
      <a
        href="javascript:;"
        v-bind="attrs"
        v-on="on"
      >
        ({{ $t('Outbox.More') }})
      </a>
    </template>
    <v-card>
      <v-card-title class="text-h5">
        {{ title }} ({{ entities.length }}{{ $t('Outbox.Count') }})
      </v-card-title>
      <v-card-text>
        <ul>
          <li
            v-for="(entity,k) in entities"
            :key="k"
          >
            {{ $chPtObjData('chinName', entity) }}
          </li>
        </ul>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="primary"
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    entities: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      dialog: false
    }
  }
}
</script>
